import React, { useState, useEffect } from "react";

const Clock = () => {
    const [time, setTime] = useState("");

    useEffect(() => {
        const interval = setInterval(() => {
            let current = new Date();
            current.toLocaleString();
            let date = current.toLocaleDateString();
            let time = current.toLocaleTimeString();
            current = date + " " + time;
            setTime(current);
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return <span className='text-lg font-thin'>{time}</span>;
};

export default Clock;
